import * as types from "../actions/types/openApi.types";

const initialState = {
    tokenExpiryState: "loading",
    tokenExpiryMessage: "",
    tokenExpiryData: {},
};

export const openApiTokenReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_TOKEN_EXPIRY_INPROGRESS:
            return {
                ...state,
                tokenExpiryState: "loading",
            };
        case types.GET_TOKEN_EXPIRY_FAILURE:
            return {
                ...state,
                tokenExpiryState: "failed",
                tokenExpiryMessage: action.message,
            };
        case types.GET_TOKEN_EXPIRY_SUCCESS:
            return {
                ...state,
                tokenExpiryState: "success",
                tokenExpiryMessage: action.message,
                tokenExpiryData: action.data,
            };
        default:
            return state;
    }
};
